export const DOWNLOAD_STATUS: string = "DOWNLOAD_STATUS";

export function setDownloadStatus(status: boolean): IDownloadStatusType {
    return { type: DOWNLOAD_STATUS, downloadStatus: status }
}

interface IDownloadStatusType { 
    type: string, 
    downloadStatus: boolean 
}
